<template lang="pug">

  .profile-component
    form(@submit.prevent='update', @keydown='form.onKeydown($event)', :class="{ 'has-errors': form.errors.any() }")
      slot

    modal.password-change-modal(v-if="showPasswordChangeModal", @close="showPasswordChangeModal = false")
      form(@submit.prevent='changePassword', @keydown='passwordForm.onKeydown($event)', :class="{ 'has-errors': passwordForm.errors.any() }")
        .v-modal-title Provide the following information to change your password.
        .v-modal-message.mx-auto.text-left
            form-group-row(:form='passwordForm', :label="$t('profile.current_password')", name='current_password')
              form-input(:form='passwordForm', name='current_password', type='password') 
            form-group-row(:form='passwordForm', :label="$t('profile.password')", name='password')
              form-input(:form='passwordForm', name='password', type='password') 
            form-group-row(:form='passwordForm', :label="$t('profile.confirm_password')", name='password_confirmation')
              form-input(:form='passwordForm', name='password_confirmation', type='password') 
        .v-modal-buttons
          v-button.btn-primary(:loading='passwordForm.busy') {{ $t('profile.submit') }}

    modal(v-if="showProfileChangeSuccessModal", @close="showProfileChangeSuccessModal = false")
      .v-modal-title Success!
      .v-modal-message Your profile has been changed.

    modal(v-if="showPasswordChangeSuccessModal", @close="showPasswordChangeSuccessModal = false")
      .v-modal-title Success!
      .v-modal-message Your passsword has been changed.

</template>

<script>
import Form from 'vform'
import { mapGetters } from 'vuex'
import PictureInput from 'vue-picture-input'
import axios from 'axios';
import Datepicker from 'vuejs-datepicker';
import moment from 'moment';

export default {
  name: 'profile',

  data: () => ({
    showPasswordChangeModal: false,
    showProfileChangeSuccessModal: false,
    showPasswordChangeSuccessModal: false,
    form: new Form(),
    passwordForm: new Form({
      current_password: '',
      password: '',
      password_confirmation: ''
    })
  }),

  computed: mapGetters({
    user: 'authUser'
  }),

  async created() {
    this.$store.dispatch('authGuard', this);
    this.fillForm();
  },

  methods: {
    fillForm() {
      this.form.keys().forEach(key => {
        this.form[key] = this.user[key]
      });
    },

    async update () {
      const { data } = await this.form.put(`${window.addiesaas.url}/api/user/${this.user.id}`)
      this.$store.dispatch('updateUser', { user: data.data })
      this.form.reset()
      this.fillForm();
      this.error = null;
      this.showProfileChangeSuccessModal = true;
    },

    onPictureChange () {
      this.form.picture = this.$refs.pictureInput.image;
    },

    async changePassword() {
      await this.passwordForm.patch(`${window.addiesaas.url}/api/settings/password`)
      this.showPasswordChangeModal = false
      this.showPasswordChangeSuccessModal = true
    }
  },

  components: {
    PictureInput,
    Datepicker
  }
}
</script>
